import { Component, OnInit, Input, Output, EventEmitter, Renderer2, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { EventService } from '../../../core/services/event.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { ScriptService } from "src/app/core/services/script.service";
import { FiltrosPersistenciaService } from 'src/app/core/services/filtros-persistencia.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import Swal from 'sweetalert2';
import { formatDate } from '@angular/common';

import { HostListener } from '@angular/core';

@Component({
  selector: 'app-filtrocampo-inline',
  templateUrl: './filtrocampo-inline.component.html',
  styleUrls: ['./filtrocampo-inline.component.scss']
})
export class FiltrocampoInlineComponent implements OnInit {

  @Input() Mostrartitulofiltro: boolean = false;
  @Input() ToolbarMS: any;
  @Input() form_template: any[];
  @Input() strListener: string = '';
  @Input() EventoCerrarMSNavID: string = '';
  @Input() blnMostrarBusqueda: boolean = false;
  @Input() TipoPantalla: string = '';
  @Input() JavaScript: string = "";
  @Input() FormID: string = "";
  @Input() FiltrosAvan;
  @Input() blnAccionbuscar: any;
  @Input() formFiltros = null;
  @Input() MostrarbotonBuscar: any;
  @Input() AccionesOnChange = [];
  @Input() reporteSel = null;
  @Input() SYS02CON: string | number = '';

  @Output() eventoFiltros = new EventEmitter();
  @Output() cerrar = new EventEmitter<String>();
  @Output() abrirReportes = new EventEmitter<String>();
  @Output() EventoCerrarMsInterno = new EventEmitter<boolean>();

  myFormGroup: FormGroup;
  Indice: number;
  campo: string[] = [];
  strWsURLModal: string = '';
  WsFiltroModal = [];
  strTituloPantallaModal: string = '';
  scriptElement: any;
  campos: any;
  isCollapsed = true;
  modal_element_label: any;
  modal_element_type: any;
  formespecial = [];
  ngmodels = new Object();
  private versionesPropagacionCombo = new Map<string, number>();

  constructor(private eventService: EventService,
    private dataService: SharedService,
    private renderer: Renderer2,
    private scriptService: ScriptService,
    private modalService: NgbModal,
    private filtrosPersistencia: FiltrosPersistenciaService
  ) { }

  ngOnInit(): void {
    this.CrearFormulario();

    if (this.FiltrosAvan == 1) {
      this.isCollapsed = false;
    }
    // almora 2026.05.15 — Pre-rellena el formulario de reportes con los filtros
    // guardados (globales + particulares de la pantalla).
    this.aplicarFiltrosPersistencia();
    this.aplicarAccionesReporte();
  }

  private aplicarAccionesReporte(): void {
    if (!this.myFormGroup || !this.reporteSel) return;

    this.Select_ocultar({
      label: 'SYS10CON',
      value: String(this.reporteSel.SYS10CON)
    });
  }

  @HostListener('keydown.enter')
  onEnter() {
    this.ValidarFormulario();
  }

  ngAfterViewInit(): void {
    this.CargarScript();
  }

  CargarScript() {
    if (this.JavaScript !== "undefined") {
      if (this.JavaScript != "")
        this.scriptElement = this.scriptService.loadJsScript(this.renderer, this.JavaScript);
    }
  }

  CrearFormulario() {
    let group = {};

    if (this.form_template !== undefined && this.form_template !== null) {
      for (const i in this.form_template) {
        if (this.FiltrosAvan == "1") {
          for (const j in this.form_template[i].FiltrosAvanzado) {

            let valor = this.form_template[i].FiltrosAvanzado[j].value;
            if (this.form_template[i].FiltrosAvanzado[j].label == "M12CAR") {
              this.campos = JSON.parse("{ \"M12CAR\" : \"" + valor + "\"}")
            }
            if (this.form_template[i].FiltrosAvanzado[j].type == 'textbox_date' && valor != '') {
              valor = formatDate(valor, 'dd/MM/yyyy', 'en');
            }
            if (this.form_template[i].FiltrosAvanzado[j].type == 'select_multiple' && valor != '') {
              this.ngmodels[this.form_template[i].FiltrosAvanzado[j].label] = [];
            }
            if (this.form_template[i].FiltrosAvanzado[j].SYS03ALI != undefined) {
              this.formespecial[this.form_template[i].FiltrosAvanzado[j].label] = this.form_template[i].FiltrosAvanzado[j].SYS03ALI;
            }

            let validadores = [];
            if (this.TipoPantalla == 'REPORTE') {
              if (this.form_template[i].FiltrosAvanzado[j].validators.required) {
                validadores.push(Validators.required);

              }
              if (this.form_template[i].FiltrosAvanzado[j].A03LON > 0) {
                validadores.push(Validators.maxLength(this.form_template[i].FiltrosAvanzado[j].A03LON))
                validadores.push(Validators.minLength(0))
              }
            }

            group[this.form_template[i].FiltrosAvanzado[j].label] = new FormControl(valor, validadores);
          }
        } else {

          for (const j in this.form_template[i].FiltrosExpuestos) {
            let valor = this.form_template[i].FiltrosExpuestos[j].value;
            if (this.form_template[i].FiltrosExpuestos[j].label == "M12CAR") {
              this.campos = JSON.parse("{ \"M12CAR\" : \"" + valor + "\"}")
            }
            if (this.form_template[i].FiltrosExpuestos[j].type === 'textbox_date' && valor !== '') {
              valor = formatDate(valor, 'dd/MM/yyyy', 'en');
            }
            if (this.form_template[i].FiltrosExpuestos[j].type === 'select_multiple' && valor !== '') {
              this.ngmodels[this.form_template[i].FiltrosExpuestos[j].label] = [];
            }
            if (this.form_template[i].FiltrosExpuestos[j].SYS03ALI !== undefined) {
              this.formespecial[this.form_template[i].FiltrosExpuestos[j].label] = this.form_template[i].FiltrosExpuestos[j].SYS03ALI;
            }

            let validadores = [];
            if (this.TipoPantalla == 'REPORTE') {
              if (this.form_template[i].FiltrosExpuestos[j].validators.required) {
                validadores.push(Validators.required);

              }
              if (this.form_template[i].FiltrosExpuestos[j].A03LON > 0) {
                validadores.push(Validators.maxLength(this.form_template[i].FiltrosExpuestos[j].A03LON))
                validadores.push(Validators.minLength(0))
              }
            }

            group[this.form_template[i].FiltrosExpuestos[j].label] = new FormControl(valor, validadores);
          }

          for (const j in this.form_template[i].FiltrosAvanzado) {
            let valor = this.form_template[i].FiltrosAvanzado[j].value;
            if (this.form_template[i].FiltrosAvanzado[j].label == "M12CAR") {
              this.campos = JSON.parse("{ \"M12CAR\" : \"" + valor + "\"}")
            }
            if (this.form_template[i].FiltrosAvanzado[j].type == 'textbox_date' && valor != '') {
              valor = formatDate(valor, 'dd/MM/yyyy', 'en');
            }
            if (this.form_template[i].FiltrosAvanzado[j].type == 'select_multiple' && valor != '') {
              this.ngmodels[this.form_template[i].FiltrosAvanzado[j].label] = [];
            }
            if (this.form_template[i].FiltrosAvanzado[j].SYS03ALI != undefined) {
              this.formespecial[this.form_template[i].FiltrosAvanzado[j].label] = this.form_template[i].FiltrosAvanzado[j].SYS03ALI;
            }

            let validadores = [];
            if (this.TipoPantalla == 'REPORTE') {
              if (this.form_template[i].FiltrosAvanzado[j].validators.required) {
                validadores.push(Validators.required);

              }
              if (this.form_template[i].FiltrosAvanzado[j].A03LON > 0) {
                validadores.push(Validators.maxLength(this.form_template[i].FiltrosAvanzado[j].A03LON))
                validadores.push(Validators.minLength(0))
              }
            }

            group[this.form_template[i].FiltrosAvanzado[j].label] = new FormControl(valor, validadores);
          }
        }
      }

    }
    this.myFormGroup = null;
    this.myFormGroup = new FormGroup(group);
  }

  toggleAvanzados() {
    this.isCollapsed = !this.isCollapsed;
    this.abrirReportes.emit("1");
  }

  DemeFormulario() {
    if (this.myFormGroup.valid) {
      // Persiste los valores crudos antes de formatear (formatearFormulario muta el objeto).
      this.persistirFiltros();
      return this.formatearFormulario(this.myFormGroup.value);
    } else {
      return 0;
    }
  }

  formatearFormulario(form) {
    for (const key in form) {
      if (form[key] == null) {
        form[key] = "";
      }

      if (Array.isArray(form[key])) {

        form[key] = "'" + form[key].join("','") + "'";

      }
      if (form[key] == Number(form[key])) {
        form[key] = String(form[key]);
      }

      let elemento = this.getElemento(key);
      if (elemento.type == "textbox_date" && form[key] != "" && form[key].includes('-')) {
        form[key] = formatDate(form[key], 'dd/MM/yyyy', 'en');
      }
    }

    return form;
  }



  getElemento(label) {
    for (const i in this.form_template) {
      for (const j in this.form_template[i].FiltrosExpuestos) {
        if (this.form_template[i].FiltrosExpuestos[j].label == label) {
          return this.form_template[i].FiltrosExpuestos[j];
        }
      }

      for (const j in this.form_template[i].FiltrosAvanzado) {
        if (this.form_template[i].FiltrosAvanzado[j].label == label) {
          return this.form_template[i].FiltrosAvanzado[j];
        }
      }
    }
  }


  ValidarFormulario() {
    if (this.myFormGroup.valid) {
      let objForm = this.myFormGroup.value;
      this.guardarBusqueda(objForm, this.strListener);
      if (this.formFiltros != null) {
        objForm = { ...objForm, ...this.formFiltros };
      }
      this.eventoFiltros.emit(objForm);
      this.eventService.broadcast('EVENTO_REFRESAR_LISTA_' + this.strListener, JSON.stringify(objForm));
    }
    this.campo = [];
    this.cerrarmodal();
  }

  cerrarmodal() {
    this.cerrar.emit("1");
  }

  AbrirModal(contenido, elemento) {

    this.modal_element_label = elemento.label;
    this.modal_element_type = elemento.type;
    this.WsFiltroModal = [{ ...this.formatearFormulario(this.myFormGroup.value) }];
    this.strWsURLModal = "api/mantenimientos/ListarGenerico/" + elemento.id_modal;
    this.strTituloPantallaModal = elemento.titulo_modal;
    this.modalService.open(contenido, { size: 'xl' });
  }

  RetornoModal(event) {

    if (event.length > 0) {
      let retorno = event[0];
      let claves = Object.keys(retorno);
      claves.forEach((key) => {
        if (key == "TSTAMP") {
          key = this.myFormGroup.value.TSTAMP;
        } else if (this.modal_element_label == key) {
          const formControl = this.myFormGroup.get(key);
          if (formControl) {
            formControl.setValue(retorno[key]);
          }
        } else if (this.modal_element_label != key) {
          if (this.TienePropiedad(key)) {
            if (claves.length <= 2) {
              const formControl = this.myFormGroup.get(this.modal_element_label);
              formControl.setValue(retorno[key]);
            } else {
              const formControl = this.myFormGroup.get(key);
              formControl.setValue(retorno[key]);
            }
          } else {
            const formControl = this.myFormGroup.get(key);
            if (formControl != null) {
              formControl.setValue(retorno[key]);
            }
          }
        }
      });
    }

    this.modalService.dismissAll();
  }

  TienePropiedad(propiedad) {
    for (const key in this.formespecial) {
      if (this.formespecial[key] == propiedad && key == this.modal_element_label) {
        return true;
      }
    }
    return false;
  }

  ngOnDestroy(): void {
    if (this.form_template !== undefined && this.form_template != null) {
      this.form_template.forEach(input_template => {
        input_template = null;
      });
    }
    if (this.myFormGroup) {
      this.myFormGroup.reset();
      this.myFormGroup = null;
    }
    this.form_template = null;
    if (this.JavaScript != "" && this.scriptElement)
      this.scriptElement.parentNode.removeChild(this.scriptElement);
  }

  EventoClickMS(obj, url, evento) {
    if (evento == "EVENTO_CERRAR") {
      this.eventService.broadcast("EventoCerrarMS_" + this.EventoCerrarMSNavID, JSON.parse('{}'));
      this.CerrarMsInternoClick(false);
    } else {
      if (this.myFormGroup.valid) {
        let llaves: Array<string> = [];
        llaves.push(this.myFormGroup.value);

        var jsonFiltros = this.toJSON(evento, llaves, url);

        this.dataService.ConsultarWS(url, jsonFiltros).subscribe(
          (datosResp: any) => {

            this.eventService.broadcast('EVENTO_REFRESAR_LISTA_' + this.strListener, JSON.parse('{}'));

            this.eventService.broadcast("EventoCerrarMS_" + this.EventoCerrarMSNavID, JSON.parse('{}'));

            this.CerrarMsInternoClick(true);
          },
          error => {
            Swal.fire({
              title: 'Error',
              text: error,
              icon: 'error',
            })
          }
        );
      } else {
        alert('Por favor verifique los campos requeridos.');
      }
      this.campo = [];
    }
  }

  toJSON(operacion: string, arr: any[], url?: string, extra?: string) {
    return JSON.parse("{ \"LLAVES\"   :" + JSON.stringify(arr) +
      (url != null ? (", \"URL\"      :\"" + url + "\"") : "") +
      (extra != null ? ("," + extra) : "") +
      ", \"OPERACION\":\"" + operacion + "\"}");
  }

  CerrarMsInternoClick(blnRefrescar: boolean) {
    this.EventoCerrarMsInterno.emit(blnRefrescar);
  }

  CboClick(elemento, insert = false, recorrido: string[] = []) {
    if (!elemento || !this.myFormGroup || recorrido.includes(elemento.label)) return;
    const nuevaRuta = [...recorrido, elemento.label];
    this.invalidarPropagacionCombo(elemento, new Set<string>(nuevaRuta));
    if (elemento.ComboClick == "S") {
      this.form_template.forEach((input_template) => {
        for (let i = 0; i < input_template.FiltrosAvanzado.length; i++) {
          if (input_template.FiltrosAvanzado[i].label == elemento.ComboClickDestName) {
            // almora 2026.05.16 - Se guarda el valor previo del combo dependiente para
            // re-aplicarlo cuando lleguen las nuevas opciones (asi sobrevive un valor
            // preseleccionado por persistencia).
            const destLabel = input_template.FiltrosAvanzado[i].label;
            if (nuevaRuta.includes(destLabel)) continue;
            const valorDestPrevio = this.myFormGroup.get(destLabel)?.value;
            const version = this.versionesPropagacionCombo.get(destLabel);
            let llaves = JSON.stringify(this.formatearFormulario(this.myFormGroup.value));
            let jsonFiltros = JSON.parse('{ "LLAVES"   : [' + llaves + "]}");
            this.dataService.Ejecutar("api/mantenimientos/ListarCombo/" + input_template.FiltrosAvanzado[i].ComboClickURL, jsonFiltros).subscribe(
              (datosResp: any) => {
                if (!this.myFormGroup ||
                    this.versionesPropagacionCombo.get(destLabel) !== version) return;
                input_template.FiltrosAvanzado[i].options = datosResp;
                this.reaplicarValorCombo(destLabel, valorDestPrevio, datosResp);
                this.continuarPropagacionCombo(input_template.FiltrosAvanzado[i], insert, nuevaRuta);
              },
              (error) => {
                if (!this.myFormGroup ||
                    this.versionesPropagacionCombo.get(destLabel) !== version) return;
                Swal.fire({
                  html:
                    '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                    '<div class="col-5">' +
                    ' <img src="assets/images/imageerror.png"> </img>' +
                    "</div>" +
                    ' <div class="col-7">' +
                    "<h3>Error</h3><br>" +
                    " <p>" +
                    error +
                    "</p>" +
                    " </div> ",
                });
              }
            );
          }
        }

        for (let i = 0; i < input_template.FiltrosExpuestos.length; i++) {
          if (input_template.FiltrosExpuestos[i].label == elemento.ComboClickDestName) {
            // almora 2026.05.16 - Ver nota en el bloque FiltrosAvanzado de arriba.
            const destLabel = input_template.FiltrosExpuestos[i].label;
            if (nuevaRuta.includes(destLabel)) continue;
            const valorDestPrevio = this.myFormGroup.get(destLabel)?.value;
            const version = this.versionesPropagacionCombo.get(destLabel);
            let llaves = JSON.stringify(this.formatearFormulario(this.myFormGroup.value));
            let jsonFiltros = JSON.parse('{ "LLAVES"   : [' + llaves + "]}");
            this.dataService.Ejecutar("api/mantenimientos/ListarCombo/" + input_template.FiltrosExpuestos[i].ComboClickURL, jsonFiltros).subscribe(
              (datosResp: any) => {
                if (!this.myFormGroup ||
                    this.versionesPropagacionCombo.get(destLabel) !== version) return;
                input_template.FiltrosExpuestos[i].options = datosResp;
                this.reaplicarValorCombo(destLabel, valorDestPrevio, datosResp);
                this.continuarPropagacionCombo(input_template.FiltrosExpuestos[i], insert, nuevaRuta);
              },
              (error) => {
                if (!this.myFormGroup ||
                    this.versionesPropagacionCombo.get(destLabel) !== version) return;
                Swal.fire({
                  html:
                    '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                    '<div class="col-5">' +
                    ' <img src="assets/images/imageerror.png"> </img>' +
                    "</div>" +
                    ' <div class="col-7">' +
                    "<h3>Error</h3><br>" +
                    " <p>" +
                    error +
                    "</p>" +
                    " </div> ",
                });
              }
            );
          }
        }
      });
    }
  }

  // Invalida respuestas anteriores de la cadena sin cambiar las consultas originales.
  private invalidarPropagacionCombo(elemento: any, visitados: Set<string>): void {
    if (elemento.ComboClick !== 'S' || !elemento.ComboClickDestName) return;
    const destino = this.getElemento(elemento.ComboClickDestName);
    if (!destino || visitados.has(destino.label)) return;
    visitados.add(destino.label);
    this.versionesPropagacionCombo.set(
      destino.label, (this.versionesPropagacionCombo.get(destino.label) || 0) + 1
    );
    this.invalidarPropagacionCombo(destino, visitados);
  }

  // setValue no dispara (change) en ng-select: contin�a al siguiente combo expl�citamente.
  private continuarPropagacionCombo(
    destino: any, insert: boolean, recorrido: string[]
  ): void {
    const control = this.myFormGroup?.get(destino.label);
    if (control && control.value != null && control.value !== '' &&
        !Array.isArray(control.value) && Array.isArray(destino.options)) {
      const existe = destino.options.some(
        opcion => opcion != null && String(opcion.value) === String(control.value)
      );
      if (!existe) {
        control.setValue(null, { emitEvent: false });
        destino.value = null;
      }
    }
    if (destino.ComboClick === 'S') {
      this.CboClick(destino, insert, recorrido);
    }
  }

  guardarBusqueda(formulario, strListener, guardado = null) {
    localStorage.setItem("busqueda" + strListener, JSON.stringify(formulario));
  }

  Select_ocultar(elemento, evento = null) {
    let elementoValor = elemento.value;
    if (evento != null) {
      if (elemento.type == 'checkbox') {
        if (evento.target.checked == true) {
          elementoValor = elemento.CheckBoxTrue;
        } else {
          elementoValor = elemento.CheckBoxFalse;
        }
      } else if (elemento.type == 'radio') {
        if (evento.target.value == 'on') {
          elementoValor = this.myFormGroup.get(elemento.label).value;
        }
      } else {
        elementoValor = evento.target.value;
      }
    }

    for (const i in this.AccionesOnChange) {
      let campoOrigen = this.AccionesOnChange[i].Campo;
      let campoValores = this.AccionesOnChange[i].Valores.split(',');
      if (campoOrigen == elemento.label) {
        let camposDestino = this.AccionesOnChange[i].Destino.split(',');
        for (const j in camposDestino) {
          let elementoDestino = this.getElemento(camposDestino[j]);
          if (campoValores.includes(elementoValor)) {
            if (this.AccionesOnChange[i].OcultarDestino == 'S') {
              elementoDestino.oculta = true;
              this.myFormGroup.get(elementoDestino.label).setValue(null);
              if (elementoDestino.validators.required) {
                this.myFormGroup.get(elementoDestino.label).removeValidators(Validators.required);
                this.myFormGroup.get(elementoDestino.label).updateValueAndValidity();
              }
            }

            if (this.AccionesOnChange[i].AsignarValor == 'S') {
              this.myFormGroup.get(camposDestino[j]).setValue(this.AccionesOnChange[i].ValorAsignar);
            }
          } else {
            elementoDestino.oculta = false;
            if (elementoDestino.validators.required) {
              this.myFormGroup.get(elementoDestino.label).addValidators(Validators.required);
              this.myFormGroup.get(elementoDestino.label).updateValueAndValidity();
            }
          }
        }
      }
    }
  }

  clasesElemento(elemento) {
    if (elemento.oculta) {
      return "ocultar-div";
    }
    return "col-12 inline-field-wrapper";
  }

  reiniciarFormulario() {
    this.myFormGroup.reset();
    if (this.TipoPantalla === 'REPORTE' && this.SYS02CON) {
      // "Limpiar" borra solo los filtros particulares de esta pantalla;
      // los globales (M05/M18/M19/CNT05) se mantienen y se vuelven a aplicar.
      this.filtrosPersistencia.limpiarParticulares(this.SYS02CON);
      this.aplicarFiltrosPersistencia();
    }
  }

  /**
   * Pre-rellena el formulario con los filtros guardados (globales + particulares de la
   * pantalla). Solo aplica en pantallas de tipo REPORTE con SYS02CON conocido.
   */
  private aplicarFiltrosPersistencia(): void {
    if (this.TipoPantalla !== 'REPORTE' || !this.SYS02CON || this.myFormGroup == null) return;
    const aplicables = this.filtrosPersistencia.getAplicables(this.SYS02CON, this.camposPersistibles());
    Object.keys(aplicables).forEach(label => {
      const control = this.myFormGroup.get(label);
      if (control == null) return;
      const valor = aplicables[label];
      control.setValue(valor);
      const elemento = this.getElemento(label);
      if (elemento && elemento.type === 'select_multiple') {
        // select_multiple usa ngModel ademas de formControlName; sincronizamos ambos.
        this.ngmodels[label] = valor;
        elemento.value = valor;
      }
    });
    // almora 2026.05.16 - Recarga las opciones de los combos dependientes (ej. M19COD que
    // depende de M18COD): el valor del combo padre se asigno por codigo y su (change) no
    // dispara CboClick, asi que sin esto el combo hijo se quedaria sin opciones.
    this.recargarCombosDependientes();
  }

  /**
   * Dispara CboClick para cada combo "padre" (ComboClick=='S') que ya tenga un valor en
   * el formulario, recargando las opciones de sus combos dependientes. Es necesario tras
   * precargar filtros persistidos: el (change) del combo padre (ej. M18COD) NO se dispara
   * cuando el valor se asigna por codigo, asi que el combo hijo (ej. M19COD) se quedaria
   * sin opciones y su valor preseleccionado no se veria. (almora 2026.05.16)
   */
  private recargarCombosDependientes(): void {
    if (this.myFormGroup == null || this.form_template == null) { return; }
    const procesar = (elem: any) => {
      if (elem == null || elem.ComboClick !== 'S') { return; }
      const control = this.myFormGroup.get(elem.label);
      if (control != null && control.value != null && control.value !== '') {
        this.CboClick(elem);
      }
    };
    this.form_template.forEach((grupo: any) => {
      (grupo.FiltrosExpuestos || []).forEach(procesar);
      (grupo.FiltrosAvanzado || []).forEach(procesar);
    });
  }

  /**
   * Tras recargar las opciones de un combo dependiente, vuelve a fijar su valor previo si
   * sigue siendo valido (existe en las nuevas opciones). Evita que el valor preseleccionado
   * por persistencia se pierda al reemplazarse el arreglo de opciones. (almora 2026.05.16)
   */
  private reaplicarValorCombo(label: string, valor: any, opciones: any[]): void {
    if (valor == null || valor === '' || !Array.isArray(opciones)) { return; }
    const control = this.myFormGroup == null ? null : this.myFormGroup.get(label);
    if (control == null) { return; }
    const existe = opciones.some(o => o != null && String(o.value) === String(valor));
    if (existe) {
      control.setValue(valor, { emitEvent: false });
    }
  }

  /** Persiste el formulario actual (valores crudos) descomponiendo globales/particulares. */
  private persistirFiltros(): void {
    if (this.TipoPantalla !== 'REPORTE' || !this.SYS02CON || this.myFormGroup == null) return;
    this.filtrosPersistencia.guardarFiltrosFromForm(this.SYS02CON, { ...this.myFormGroup.value });
  }

  /** Labels de todos los campos que el formulario de filtros expone (expuestos + avanzados). */
  private camposPersistibles(): string[] {
    const campos: string[] = [];
    (this.form_template || []).forEach((grupo: any) => {
      (grupo.FiltrosExpuestos || []).forEach((f: any) => { if (f && f.label) campos.push(f.label); });
      (grupo.FiltrosAvanzado || []).forEach((f: any) => { if (f && f.label) campos.push(f.label); });
    });
    return campos;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.form_template != null) {
      if (this.myFormGroup != undefined) {
        for (const i in this.form_template) {
          for (const j in this.form_template[i].FiltrosAvanzado) {
            let control = this.myFormGroup.get(
              this.form_template[i].FiltrosAvanzado[j].label
            );
            if (
              this.form_template[i].FiltrosAvanzado[j].type == 'select' &&
              control?.value != ''
            ) {
              this.CboClick(this.form_template[i].FiltrosAvanzado[j]);
            }
          }

          for (const j in this.form_template[i].FiltrosExpuestos) {
            let control = this.myFormGroup.get(
              this.form_template[i].FiltrosExpuestos[j].label
            );
            if (
              this.form_template[i].FiltrosExpuestos[j].type == 'select' &&
              control?.value != ''
            ) {
              this.CboClick(this.form_template[i].FiltrosExpuestos[j]);
            }
          }
        }
      }
    }

    if (
      changes.blnAccionbuscar != null &&
      changes.blnAccionbuscar.previousValue != null
    ) {
       // Se difiere para no mutar formFiltros del padre dentro del mismo ciclo
      // de deteccion de cambios (evita NG0100 ExpressionChangedAfterItHasBeenChecked)
      Promise.resolve().then(() => this.ValidarFormulario());
    }

    // Este es el único bloque que cambia:
    if (changes.reporteSel != null && this.myFormGroup) {
      this.aplicarAccionesReporte();
    }
  }

}